// extracted by mini-css-extract-plugin
export default {"box":"Home_box__O2gHw","nav":"Home_nav__mkSvu"};